import { useCallback } from "react"
import { graphql, useMutation } from "react-relay"
import { UpdateAppointmentFlexibilityInput } from "@/modules/waiting-room/services/__generated__/useUpdateAppointmentFlexibilityMutation.graphql"

const mutation = graphql`
  mutation useUpdateAppointmentFlexibilityMutation($input: UpdateAppointmentFlexibilityInput!) {
    updateAppointmentFlexibility(input: $input) {
      waitingRoomAppointment {
        flexibility
        appointment {
          urgency
          flexibility
          reviewStatus
        }
      }
    }
  }
`

export function useUpdateAppointmentFlexibilityMutation() {
  const [commit] = useMutation(mutation)

  return useCallback(
    (input: UpdateAppointmentFlexibilityInput, handleComplete?: () => void) => {
      commit({
        variables: { input },
        onCompleted: handleComplete,
      })
    },
    [commit],
  )
}
